import React from "react";

import { injectGlobal } from "styled-components";
import { Row, Col } from "react-grid-system";

import { color } from "./../style/Variables";
import Content from "./Content.js";
import Navigation from "./../Navigation.js";
import Footer from "./../Footer.js";
import CopyProvider from "./../CopyProvider.js";

injectGlobal`
  #legalPages {
    nav {
      top: 0;
      height: 90px;
      background: ${color.light_blue_grey_two};

      .menu-item {
        display: none;
      }
    }
  }
`;

class Legal extends React.Component {
  static locales = {
    en: "Legal/en.js",
    de: "Legal/de.js",
  };
  state = {
    scroll: this.getWindowScrollY(),
  };
  onScroll = evt => {
    this.setState({ scroll: this.getWindowScrollY() });
  };
  onResize = evt => {
    this.setState({ scroll: this.getWindowScrollY() });
  };
  getWindowScrollY() {
    return window.scrollY || window.pageYOffset;
  }
  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize, { passive: true });
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }
  render() {
    const passdown = {
      ...this.props,
      scroll: this.state.scroll,
    };
    return (
      <div id="legalPages">
        <Navigation {...passdown} />
        <CopyProvider
          locale={this.props.match.params.locale}
          locales={Legal.locales}
        >
          <Row className="content h-100 pt9 pb3 px2">
            <Col lg={8} offset={{ lg: 2 }}>
              <Content {...passdown} />
            </Col>
          </Row>
        </CopyProvider>
        <Footer />
      </div>
    );
  }
}

export default Legal;



// WEBPACK FOOTER //
// ./src/Legal/Legal.js